module.exports = __webpack_public_path__ + "img/upgrade_img3.1fd83fe5.png";